import angular from 'angular';

GraficosDetailCtrl.$inject = ['$stateParams', '$scope', 'GraficoLocalService', 'FiltrosActivos', 'InformeActionsService'];
export default function GraficosDetailCtrl($stateParams, $scope, GraficoLocalService, FiltrosActivos, InformeActionsService) {

    let vm = this;
    vm.grafico = null;
    let valores = null;
    vm.loading = {grafico: true};
    vm.pudeAnyadirAInforme = Sigo.user.puedeGestionarInformesEstadisticas;

    cargarGrafico($stateParams.id).then(function (grafico) {
        pintarGrafico(grafico, FiltrosActivos.getFiltros());
    });

    vm.actualizarFiltros = function (valor) {
        valores = valor;
        pintarGrafico(vm.grafico, valor);
    };

    vm.anyadirAInforme = function (grafico) {
        InformeActionsService.anyadirGraficoAInforme(grafico);
    };

    vm.puedeCambiarVisualizacion = function () {
        if (vm.grafico == null) return false;
        return vm.grafico.tipo === "pie" || vm.grafico.tipo === "bar";
    };

    vm.cambiarVisualizacion = function () {
        vm.grafico.tipo = vm.grafico.tipo === "pie" ? "bar" : "pie";
        vm.actualizarFiltros(valores);
    };

    vm.textoBtnCambiar = function () {
        if (vm.grafico == null) return "";
        if (vm.grafico.tipo === "pie") return "estadisticas.btn_cambiar_a_bar";
        if (vm.grafico.tipo === "bar") return "estadisticas.btn_cambiar_a_pie";
        return "";
    };

    function cargarGrafico(id) {
        vm.loading.grafico = true;
        let promesa = GraficoLocalService.getGraficoById(id);
        promesa.then(function (grafico) {
            vm.grafico = grafico;
            vm.loading.grafico = false;
        }, function () {
            throw new Error('No existe ningún gráfico con la id: ' + id);
        });
        return promesa;
    }

    function pintarGrafico(grafico, parametros) {
        let copiaParametros = issetAndNotEmpty(parametros) ? angular.copy(parametros) : undefined;

        if (typeof copiaParametros != 'undefined' && copiaParametros != null && Object.keys(copiaParametros).length > 0) {
            if (typeof copiaParametros.rangoFechas != 'undefined') {
                copiaParametros.start = copiaParametros.rangoFechas.start;
                copiaParametros.end = copiaParametros.rangoFechas.end;
                delete copiaParametros.rangoFechas;
            }

            let keys = Object.keys(copiaParametros);

            keys.forEach(function (key) {
                if (copiaParametros[key].constructor === Array)
                    copiaParametros[key] = copiaParametros[key].join(',');
            });

            grafico.parametros = copiaParametros;
        } else {
            grafico.parametros = {};
        }

        vm.grafico = grafico;
    }
}